import { render, staticRenderFns } from "./LeituraConfigNiveis.vue?vue&type=template&id=ad99b4a2&scoped=true&class=template&"
import script from "./LeituraConfigNiveis.vue?vue&type=script&lang=js&"
export * from "./LeituraConfigNiveis.vue?vue&type=script&lang=js&"
import style0 from "./LeituraConfigNiveis.vue?vue&type=style&index=0&id=ad99b4a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad99b4a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VRow})
